var _path, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchedLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 67 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3098 0C14.9431 0 0 14.9431 0 33.3098C0 38.8234 1.37851 44.2903 3.99912 49.1392L31.4882 98.8556C31.8542 99.5185 32.5515 99.9291 33.3098 99.9291C34.068 99.9291 34.7654 99.5185 35.1313 98.8556L62.6306 49.1228C65.241 44.2903 66.6195 38.8232 66.6195 33.3096C66.6195 14.9431 51.6764 0 33.3098 0ZM33.3098 49.9646C24.1264 49.9646 16.655 42.4931 16.655 33.3098C16.655 24.1264 24.1264 16.655 33.3098 16.655C42.4931 16.655 49.9646 24.1264 49.9646 33.3098C49.9646 42.4931 42.4931 49.9646 33.3098 49.9646Z",
    fill: "#395813"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 24.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12967_370779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1211 48V44.4649H31.6768C29.7329 44.4649 28.1514 42.8834 28.1514 40.9395C28.1514 38.9955 29.7329 37.414 31.6768 37.414H32.1211V33.8789H27.7071C27.2217 33.8789 26.8281 33.4854 26.8281 33V31.6768C26.8281 30.7021 26.0352 29.9092 25.0605 29.9092C24.0859 29.9092 23.2929 30.7021 23.2929 31.6768V33C23.2929 33.4854 22.8994 33.8789 22.414 33.8789H18V46.2324C18 47.2071 18.7929 48 19.7676 48H32.1211Z",
    fill: "#395813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2334 48C47.208 48 48.001 47.2071 48.001 46.2324V33.8789H44.4658V34.3232C44.4658 36.2671 42.8843 37.8486 40.9404 37.8486C38.9965 37.8486 37.415 36.2671 37.415 34.3232V33.8789H33.8799V38.2929C33.8799 38.7783 33.4864 39.1719 33.001 39.1719H31.6778C30.7031 39.1719 29.9102 39.9648 29.9102 40.9395C29.9102 41.9141 30.7031 42.7071 31.6778 42.7071H33.001C33.4864 42.7071 33.8799 43.1006 33.8799 43.586V48H46.2334Z",
    fill: "#395813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9395 36.0908C41.9141 36.0908 42.7071 35.2979 42.7071 34.3232V33C42.7071 32.5146 43.1006 32.1211 43.586 32.1211H48V19.7676C48 18.7929 47.2071 18 46.2324 18H33.8789V21.5351H34.3232C36.2671 21.5351 37.8486 23.1166 37.8486 25.0605C37.8486 27.0045 36.2671 28.586 34.3232 28.586H33.8789V32.1211H38.2929C38.7783 32.1211 39.1719 32.5146 39.1719 33V34.3232C39.1719 35.2979 39.9648 36.0908 40.9395 36.0908Z",
    fill: "#395813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7676 18C18.7929 18 18 18.7929 18 19.7676V32.1211H21.5351V31.6768C21.5351 29.7329 23.1166 28.1514 25.0605 28.1514C27.0045 28.1514 28.586 29.7329 28.586 31.6768V32.1211H32.1211V27.7071C32.1211 27.2217 32.5146 26.8281 33 26.8281H34.3232C35.2979 26.8281 36.0908 26.0352 36.0908 25.0605C36.0908 24.0859 35.2979 23.2929 34.3232 23.2929H33C32.5146 23.2929 32.1211 22.8994 32.1211 22.414V18H19.7676Z",
    fill: "#395813"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12967_370779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchedLocation);
export default __webpack_public_path__ + "static/media/Matched-location.13a03b5e308c1e437b418e0583bca637.svg";
export { ForwardRef as ReactComponent };